import * as React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  ReferenceField,
  useTranslate,
  FunctionField,
  BooleanField,
  ImageField,
} from "react-admin";
import { JsonField } from "react-admin-json-view";
import {
  DateField,
  Title,
  ShowOnlyTopToolbar,
} from "../../shared/components/index.js";

const showMerchantPaymentGateway = () => {
  const t = useTranslate();
  const merchant = localStorage.getItem("name");

  return (
    <Show title={<Title source="name" />} actions={<ShowOnlyTopToolbar />}>
      <SimpleShowLayout>
        <TextField source="name" />
        {merchant === "PetrolCard" && (
          <ReferenceField source="logo_file_id" reference="File">
            <ImageField
              source="url"
              sx={{
                "& img": { maxWidth: 60, maxHeight: 60, objectFit: "contain" },
              }}
            />
          </ReferenceField>
        )}
        <ReferenceField source="payment_gateway_id" reference="PaymentGateway">
          <TextField source="name" />
        </ReferenceField>

        <BooleanField
          source="default"
          sx={{
            "& .RaBooleanField-trueIcon": {
              color: "green",
            },
            "& .RaBooleanField-falseIcon": {
              color: "red",
            },
          }}
        />
        <JsonField
          source="config"
          reactJsonOptions={{
            name: null,
            collapsed: true,
            enableClipboard: false,
            displayDataTypes: false,
          }}
        />
        <FunctionField
          source="status"
          render={(record) =>
            t(`resources.Merchant.source.status.${record.status}`)
          }
        />
        <DateField source="created_at" />
        <DateField source="updated_at" />
      </SimpleShowLayout>
    </Show>
  );
};

export default showMerchantPaymentGateway;
